const { useEffect } = React;

function App() {
    // Resolve globals at render time (important when scripts load in different orders)
    const { Navigation, Hero, About, HowItWorks, Advantages, DualAudience, Footer } = window;

    useEffect(() => {
        // Recreate Lucide icons when component mounts
        if (typeof lucide !== 'undefined' && lucide.createIcons) {
            lucide.createIcons();
        }
    }, []);

    return (
        <div className="w-full overflow-x-hidden bg-white page-shell">
            <Navigation />
            <Hero />
            <About />
            <HowItWorks />
            <Advantages />
            <DualAudience />
            <Footer />
        </div>
    );
}

export default App;
